const developmentConfig = {
    apiUrl: 'http://localhost:4000'
}

const productionConfig = {
    apiUrl: 'https://back-api-b-m-production.up.railway.app'
}

export default process.env.NODE_ENV === 'production' ? productionConfig : developmentConfig;